var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classNames from 'classnames';
import omit from 'rc-util/lib/omit';
import { parseChildren } from './utils/nodeUtil';
import { MenuContext } from './context/MenuContext';
import { useFullPath, useMeasure } from './context/PathContext';
const InternalMenuItemGroup = (_a) => {
    var { className, title, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    eventKey, children } = _a, restProps = __rest(_a, ["className", "title", "eventKey", "children"]);
    const { prefixCls } = React.useContext(MenuContext);
    const groupPrefixCls = `${prefixCls}-item-group`;
    return (<li {...restProps} onClick={e => e.stopPropagation()} className={classNames(groupPrefixCls, className)}>
            <div className={`${groupPrefixCls}-title`} title={typeof title === 'string' ? title : undefined}>
                {title}
            </div>
            <ul className={`${groupPrefixCls}-list`}>{children}</ul>
        </li>);
};
export default function MenuItemGroup(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    const connectedKeyPath = useFullPath(props.eventKey);
    const childList = parseChildren(children, connectedKeyPath);
    const measure = useMeasure();
    if (measure) {
        return childList;
    }
    return (<InternalMenuItemGroup {...omit(props, ['warnKey'])}>
            {childList}
        </InternalMenuItemGroup>);
}
